import React, {ChangeEvent, ComponentProps, ReactNode} from 'react';
import {Field, FieldAttributes} from 'formik';

interface DataItemInputProps extends ComponentProps<'input'> {
  label?: string | null,
  sideLabel?: ReactNode | null,
  containerStyle?: string;
  topLabelStyle?: string;
  sideLabelStyle?: string;
  inputContainerStyle?: string;
  customInputStyle?: string;
}

export const DataItemInput = ({
                                label = null,
                                sideLabel = null,
                                type = 'text',
                                containerStyle = '',
                                topLabelStyle = '',
                                sideLabelStyle = '',
                                inputContainerStyle = '',
                                customInputStyle = 'custom-data-item',
                                ...rest
                              }: DataItemInputProps) => {
  return (
    <div className={containerStyle}>
      <div className={sideLabelStyle}>
        {sideLabel}
      </div>
      <div className={inputContainerStyle}>
        <label className="w-100 mb-0">
          <div className={topLabelStyle}>{label}</div>
          <div>
            <input
              className={`form-control ${customInputStyle}`}
              type={type}
              {...rest}
            />
          </div>
        </label>
      </div>
    </div>
  );
};

interface DataItemProps extends DataItemInputProps {
  fieldId: string,
  customValue?: string | null,
}

export const DataItem = ({
                           fieldId,
                           customValue = null,
                           onChange,
                           ...rest
                         }: DataItemProps) => {
  const handleInputChange = ({form, field}: FieldAttributes<any>) => (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (onChange) {
      const changedValue = onChange(e);
      form.setFieldValue(field.name, changedValue);
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({form, field}: FieldAttributes<any>) => (
        <DataItemInput
          onChange={handleInputChange({form, field})}
          value={Boolean(customValue) ? customValue : field.value}
          {...rest}
        />
      )}
    </Field>
  );
};

